var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5V32.5H32.5M31.6667 30V32.5M28.3333 28.3333V32.5M25 25.8333V32.5M21.6667 28.3333V32.5M17.5 24.1667C17.5 24.1667 22.6063 19.6631 22.5 19.5L29.5 25L33 20.5",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocks);
export default __webpack_public_path__ + "static/media/Stocks.61adb07d8eff357d565c28f36953a073.svg";
export { ForwardRef as ReactComponent };